import { AutoComplete, Input, Modal } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import "./MunicipalitySearchMobile.css";
import { surveyService } from '../../services';
import { GlobalContext } from '../../contexts/GlobalContext';


const MunicipalitySearchMobile = ({onSelect, loading, ...props}) => {
    const [municipalities, setMunicipalities] = useState([])
    const [options, setOptions] = useState([])
    const [searchTerm, setSearchTerm] = useState(null)
    const {selectedMunicipality, setSelectedMunicipality} = useContext(GlobalContext)
    const [showMunicipalitySearch, setShowMunicipalitySearch] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await surveyService.getRouterJLSWithStatus()
                const initialData = response?.map(d => (
                    {label: `${d.name} ${parseInt(d.status) && ' (Podržali projekt)' || ''}`, value: d.id + '. ' + d.name, key: d.id} //, disabled:!parseInt(d.status)
                    ))
                setMunicipalities(initialData)
                setOptions(municipalities)
            }
            catch(error) {


            }
        }
        fetchData()
    }, [])

    const handleSearch = (searchText) => {
        !searchText ? setOptions(municipalities) :
        setOptions(municipalities.filter(m => m.value.toUpperCase().includes(searchText?.toUpperCase())))

        setSearchTerm(searchTerm)
    }

    const handleFocus = (searchText) => {
        !searchTerm ? setOptions(municipalities) :
        setOptions(municipalities.filter(m => m.value.toUpperCase().includes(searchTerm?.toUpperCase())))
    }

    const handleSelect = (val, option) => {

        setSelectedMunicipality(option)
        onSelect && onSelect(option)
        toggleShowMunicipalitySearch()
    }

    const handleClear = () => {
        setSelectedMunicipality(null)
        onSelect && onSelect(null)
    }

    const toggleShowMunicipalitySearch = () => {
        setShowMunicipalitySearch(!showMunicipalitySearch)
    }

    return (<>
        <div className='municipality-search-appbar' {...props}>
           
            <Input size="large" value={selectedMunicipality && selectedMunicipality.value || null} placeholder={"Pretraga po jedinici lokalne samouprave:"} onClick={toggleShowMunicipalitySearch} />
 
        </div>
          
        <Modal
            className="municipality-search-mobile"
            visible={showMunicipalitySearch}
            onCancel={toggleShowMunicipalitySearch}
            footer={null}
            title="Pretraga jedinica lokalne samouprave"
        >

            <AutoComplete
                allowClear
                backfill
                popup_class_name="municipality-search-mobile__dropdown"
                options={options}
                onSearch={handleSearch}
                onFocus={handleFocus}
                onSelect={handleSelect}
                onClear={handleClear}
                disabled={loading}
                defaultValue={selectedMunicipality}
                //options={options.map(o => ({label: renderTitle(o.label), options: o.choices?.map(c => renderItem(c))}))}
            >
                <Input size="large" placeholder={loading && "Učitavanje jedinica lokalne samouprave..." || "Pretraga po jedinici lokalne samouprave:"} />
            </AutoComplete>
              
        </Modal>	
    </>)
}

export default MunicipalitySearchMobile;